const initShowMore = ( el ) => {
	const container = el.closest( '.cga-post-list.type-faq' );
	if ( container === null ) {
		return;
	} 

	// const postContent = container.querySelector( '.post-content-content' );
	// if ( postContent !== null ) {
	// 	const html = postContent.innerHTML;
	// 	const postTitle = container.querySelector( '.post-title' );
	// 	if ( postTitle !== null ) {
	// 		postContent.prepend( postTitle.cloneNode( true ) );
	// 		postContent.innerHTML =  postContent.innerHTML + '<span class="show-less"><span>Back</span></span>';
	// 	}
	// }

	el.addEventListener( 'click', ( ev ) => {
		ev.preventDefault();
		container.classList.add( 'show-post-content' );
	});

	const backEl = container.querySelector( '.show-less' );
	if ( backEl !== null ) {
		backEl.addEventListener( 'click', ( ev ) => {
			ev.preventDefault();
			container.classList.remove( 'show-post-content' );
		});
	}
};

const initCGAFAQShowMores = () => {
	const showMores = document.querySelectorAll( '.faqs-container .cga-post-list.type-faq .excerpt-more.show-more' );
	if ( showMores.length < 1 ) {
		return;
	}

	showMores.forEach( showMore => {
		initShowMore( showMore );
	});
};

export { initCGAFAQShowMores };